<template>
    <div class="flex flex-col gap-y-2 text-center">

        <nuxt-link :to="`/categories/${category.slug}`">
            <div class="card card--hover">

                <img
                    v-lazy="imageUrl"
                    class="card__image"
                >

            </div>
        </nuxt-link>

        <nuxt-link
            ref="name"
            :class="{ 'text-sm': smallTitle }"
            :to="`/categories/${category.slug}`"
            class="font-semibold no-underline hover:text-primary transition-fast flex flex-col gap-3 items-center"
        >
            <h3 class="font-heading text-2xl">
                {{ category.name }}
            </h3>
            <span class="tracking-widest uppercase leading-tight border-b border-grey-darker">Shop now</span>
        </nuxt-link>

        <template v-if="category.description">
            <p class="text-sm md:text-base">
                {{ category.description }}
            </p>

            <nuxt-link
                :class="{ 'text-sm': smallTitle }"
                :to="`/categories/${category.slug}`"
                class="underline hover:text-primary w-full block"
            >
                Shop {{ category.name }}
            </nuxt-link>
        </template>

    </div>
</template>

<script>
export default {

    props: {
        category: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            smallTitle: false,
        };
    },

    computed: {
        imageUrl() {
            return this.category.images ? this.category.images[0].sizes.large : this.category.image.sizes.large;
        },
    },

    mounted() {
        // make long titles smaller
        this.smallTitle = parseInt(this.$refs.name.$el.clientHeight, 10) > parseInt(window.getComputedStyle(this.$refs.name.$el).lineHeight, 10);
    },

};
</script>

<style lang="scss" scoped>
.card {
    @apply overflow-hidden relative select-none rounded transition-fast cursor-pointer;

    &__image {
        object-fit: cover;
        object-position: center;
        @apply block w-full transition-fast;
    }
}
</style>
